import clsx from 'clsx';
import React from 'react';
import classes from './BrandLogo.module.css.mjs';
import { BrandLogoPath } from './BrandLogo.utils.mjs';

const BrandLogo = ({ brand, className, ...rest }) => {
  const classNames = clsx(classes.root, "kohler-brand-logo-root", className);
  const LogoSvg = BrandLogoPath[brand];
  if (!LogoSvg) {
    console.error(`Brand logo not found for brand: ${brand}`);
    return null;
  }
  return /* @__PURE__ */ React.createElement(LogoSvg.type, { ...LogoSvg.props, className: classNames, ...rest });
};

export { BrandLogo };
